import store from "../store";
export const getTabIndex = (obj) => {
  !obj && (obj = { ...store.state.objectId });
  const item = store.state.showingTabsInHome.find((i) => {
    const { name } = i;
    const { id, classId, subClassId } = obj;
    const n = "" + id + classId + subClassId;
    return name.indexOf(n) != -1;
  });
  // return item?.index || 0;
  return item;
};


export function dragTo({ left, right, resize, box, }) {

  for (let i = 0; i < resize.length; i++) {
    // 鼠标按下事件
    resize[i].onmousedown = function (e) {
      // if (!treeOpen) {
      //   return
      // }
      //颜色改变提醒
      // resize[i].style.background = '#818181';
      left[i].style.transition = "none";
      var startX = e.clientX;
      // resize[i].left = resize[i].offsetLeft;
      // resize[i].left = 0

      const boxOffsetLeft = box[i].offsetLeft
      const leftX = resize[i].offsetLeft;


      // 鼠标拖动事件
      document.onmousemove = function (e) {

        var endX = e.clientX;
        var moveLen = leftX - boxOffsetLeft + (endX - startX); // （endx-startx）=移动的距离。resize[i].left+移动的距离=左边区域最后的宽度
        var maxT = box[i].clientWidth - resize[i].offsetWidth; // 容器宽度 - 左边区域的宽度 = 右边区域的宽度

        if (moveLen < 0) moveLen = 0; // 左边区域的最小宽度为0px
        if (moveLen > maxT - 150) moveLen = maxT - 150; //右边区域最小宽度为150px

        resize[i].style.left = moveLen; // 设置左侧区域的宽度

        for (let j = 0; j < left.length; j++) {
          left[j].style.width = moveLen + "px";
          right[j].style.width = box[i].clientWidth - moveLen - 15 + "px";
        }
      };
      // 鼠标松开事件
      document.onmouseup = function (evt) {
        //颜色恢复
        // resize[i].style.background = '#d6d6d6';
        left[i].style.transition = "0.4s";
        document.onmousemove = null;
        document.onmouseup = null;
        resize[i].releaseCapture && resize[i].releaseCapture(); //当你不在需要继续获得鼠标消息就要应该调用ReleaseCapture()释放掉
      };
      resize[i].setCapture && resize[i].setCapture(); //该函数在属于当前线程的指定窗口里设置鼠标捕获
      return false;
    };
  }
}

const LINK_LIST = [
  1003001, 1005001, 1006001, 1007007, 2000001, 1008001, 1009001, 1090001, 1096001, 1017001, 1013002, 1010002, 1015002, 1014002, 1095002, 1094002,
  1018001, 1093001, 1055001, 1054001, 4012001, 4011002,
  5013002, 5014001, 1025004, 5015001, 5011001, 5012007, 5021001, 5022001, 5016001, 5017001, 1024001,];
export const getNewTableTitleData = function (columnInfo, isCheckBox) {

  const data = [];
  if (isCheckBox !== "noCheckBox") {
    data.push({ type: "checkbox", width: 45, fixed: null, });
  }

  const { names, ids, attCtr, editable, uiTypes, listTypes, listIds, visible, listEntries } = columnInfo;

  const Arrowlist = [1003001, 5013002];
  for (let i = 0; i < attCtr; i++) {
    var obj = {
      minWidth: 120,
      title: names[i],
      field: i + "",
      attid: ids[i],
      sortable: true, //列表排序
      editable: editable[i] == 1,
      uiType: uiTypes[i],
      listType: listTypes[i] ?? 1,
      listId: listIds[i],
      treeNode: Arrowlist.includes(ids[i]), //是否有子菜单的箭头显示
      editRender: {
        enabled: editable[i] == 1,
      },
    };

    // if (i == 0) {
    // 	obj.treeNode = true; //是否有子菜单的箭头显示
    // };
    // const e = ids[i];
    // if (LINK_LIST.includes(e)) {
    //   obj.slots = {
    //     default: ({ row, column }, h) => {
    //       // 渲染链接
    //       return [
    //         <span
    //           class="link_"
    //           onClick={() => this.showDetailEvent(row, column)}
    //         >
    //           {" "}
    //           {row[column.property]}{" "}
    //         </span>,
    //       ];
    //     },
    //   };
    // }
    // if (e == 1016001 || e == 1016016) {
    //   obj.slots = {
    //     default: ({ row, column }, h) => {
    //       // 渲染链接
    //       return [
    //         <span class="link_" onClick={() => this.toLink(row, column)}>
    //           {" "}
    //           {row[column.property]}{" "}
    //         </span>,
    //       ];
    //     },
    //   };
    // }

    if (uiTypes[i] == 1) {
      obj.editRender = {
        name: "$input",
        // maxlength: '3'
        props: {
          maxlength: "240",
        },
      }; //不设置则不进入编辑模式
    } else if (uiTypes[i] == 2) {
      obj.width = 600
      obj.editRender = {
        name: "textarea",
        // maxlength: '3'
        props: {
          maxlength: "4000",
        },
      };
    } else if ([3, 4].includes(uiTypes[i])) {
      var select_id = listIds[i];

      // var val =  listEntries[select_id] || {};
      var val =
        select_id === -1 ? {} : listEntries[select_id] || {};

      let editRender = {
        name: "$select",
        props: {
          clearable: true,
          multiple: uiTypes[i] === 4,
        },
        options: [],
      };
      if (select_id != -1) {
        for (const e in val) {
          editRender.options.push({ value: e, label: val[e] });
        }
      }
      obj.editRender = editRender;
    } else if (uiTypes[i] == 6) {
      obj.editRender = {
        name: "$input",
        props: {
          type: "datetime",
          //labelFormat: 'yyyy-MM-dd HH:mm:ss'
          // labelFormat: 'yyyy-MM-ddThh:mm:ss',
          // valueFormat: 'yyyy-MM-ddThh:mm:ss',
          transfer: true,
        },
      };

    } else if (uiTypes[i] == 7) {
      obj.editRender = {
        name: "$input",
        props: {
          type: "number",
          clearable: true,
        },
      };
    } else if (uiTypes[i] == 10) {
      obj.editRender = {
        name: "$input",
        props: {
          type: "number",
          clearable: true,
        },
      };
    }

    if (visible[i] !== 0) {
      data.push(obj);
    }

    obj.editRender.enabled = !!obj.editable;
  }

  return data;
};

export const getNewTableContentData = function (rows, columnInfo, projectName) {
  //获取到table进行格式转换
  var data = [];

  var rows_val = rows ?? [];
  const { uiTypes, editable, listEntries = {}, listIds } = columnInfo;
  var rows_type = columnInfo.uiTypes;
  var rows_editable = columnInfo.editable;

  // const listEntries = columnInfo.listEntries || [];
  const listEntriesKeys = Object.keys(listEntries);
  const caslistEntries = listEntriesKeys.filter(
    (i) => Object.keys(listEntries[i]) == -1
  );
  const relTypeList = [{ id: 4, icon: "el-icon-connection" }];

  let casList = [];
  let ids = columnInfo.listIds;
  caslistEntries.map((i) => {
    listIds.map((j, e) => j == i && casList.push(e));
  });

  const enabled_ids = [1090002, 1092004];
  const enabled_indexs = columnInfo.ids.findIndex((i) =>
    enabled_ids.includes(i)
  );

  // rows.map((item, index) => {
  //   const cell = item.cells;
  // })

  for (var i = 0; i < rows_val.length; i++) {
    var rols_ = {};

    let cellDisable = [];
    let changeIdIndex = 0; //获取表格变更列的版本id


    const item = rows_val[i];
    const { rowId, fileId, authTag, filePath, hasRev, isBOM, isFile, revNumberList, } = item

    for (var j = 0; j < rows_val[0].cells.length; j++) {
      if (columnInfo.ids[j] == 1003116) {
        //获取表格变更列的版本id
        changeIdIndex = j;
      }

      if (item.cells[j] == null) {
        (rols_[j] = ""), cellDisable.push("null");
      } else {

        cellDisable.push(item.cells[j].editable);
        if (rows_type[j] == 4) {
          rols_[j] = item.cells[j]?.ids || "";
          // rols_[j] = item.cells[j].ids;
          if (rols_[j] !== "") {
            rols_[j] = rols_[j].split(";");
          }
        } else if (rows_type[j] == 3) {
          if (casList.includes(j)) {
            rols_[j] =
              item.cells[j].id == -1 ? "" : item.cells[j].id;
          } else {
            const val = item.cells[j];
            rols_[j] =
              !rows_editable[j] || (val.val && ids[j] == -1)
                ? val.val
                : val.id;
          }



        } else if (rows_type[j] == 6) {
          if (item.cells[j].val == "") {
            rols_[j] = "";
          } else {
            const [a] = item.cells[j].val.split('T')
            rols_[j] = a
          }

        } else {
          rols_[j] = item.cells[j].val;
        }
      }
    }
    if (item.hasChildren == true) {
      rols_["hasChildren"] = item.hasChildren;
    }
    rols_["cellDisable"] = cellDisable;
    rols_["itemId"] = item.objId;
    rols_["itemClassId"] = item.objClass;
    rols_["itemSubClassId"] = item.objSubClass;
    rols_["relType"] =
      relTypeList.find((item) => item.id == (item?.relType || ""))
        ?.icon || "";

    rols_.objectId = {
      id: item.objId,
      classId: item.objClass,
      subClassId: item.objSubClass,
      name: "",
    };
    rols_ = { rowId, fileId, authTag, filePath, hasRev, isBOM, isFile, revNumberList, ...rols_ };

    if (enabled_indexs != -1) {
      rols_["status"] = item.cells[enabled_indexs].id == 1;
    }

    if (projectName == "performance") {
      rols_["changeId"] = "";
    } else {
      rols_["changeId"] = item.cells[changeIdIndex].id; //获取表格变更列的版本id
    }
    data.push(rols_);

  }

  return data;
};

function setRow(xx) {

}

export function setListEntry({ listEntries, listTypes, uiTypes, listIds }, arr) {
  arr.map((i) => {
    const { cells } = i
    cells.map((m, e) => {
      if (listTypes[e] === 3) {
        if (uiTypes[e] == 3 && m.val) {
          listEntries[listIds[e]] = {
            ...listEntries[listIds[e]],
            [m.id]: m.val,
          };
        }
        if (uiTypes[e] == 4 && m.ids) {
          const ids = m.ids.split(";");
          const vals = m.val.split(";");
          const obj = {};
          ids.map((j, x) => {
            obj[j] = vals[x];
          });
          listEntries[listIds[e]] = { ...listEntries[listIds[e]], ...obj };
        }
      }
    });
  });
  return listEntries
};